import { Button, SearchInput } from "@4uhub/lib4uhub";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDashboardView } from "../../../store/contexts/DashBoardViewContext";
import { IGridModeHeaderProps } from "./models";

const TRANSLATION_PATH = "page.panels.";

export const GridModeHeader = memo(
  ({ searchHandler }: IGridModeHeaderProps) => {
    const { t } = useTranslation();

    const { isView } = useDashboardView();

    const navigate = useNavigate();

    const handleAdd = () => {
      navigate("new");
    };

    return (
      <Box
        sx={{
          pt: 2,
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5">{t(TRANSLATION_PATH + "title")}</Typography>
          {!isView && (
            <Button
              variant="contained"
              startIcon={<AddRoundedIcon />}
              onClick={handleAdd}
            >
              {t(TRANSLATION_PATH + "add")}
            </Button>
          )}
        </Box>
        <Box sx={{ pt: 2, width: "100%", maxWidth: 400 }}>
          <SearchInput
            onSearch={searchHandler}
            placeholder={t(TRANSLATION_PATH + "search")}
          />
        </Box>
      </Box>
    );
  }
);
